export default "__VITE_ASSET__bd6f1cd6__"